import { createUseStyles } from 'react-jss';
import { base } from '../../css/vars';

export default createUseStyles({
  price: {
    display: 'inline-block',
    '& > *:not(:last-child)': {
      marginRight: base(0.5),
    },
  },
});
